import { WorkflowContext } from '@samelogic/steps';
import { Schema } from 'jsonschema';
import { renderFn, get, Scope } from 'micromustache';
// TODO: take a look at this PR: https://github.com/Ajaxy/cast-with-schema/pull/12
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import castWithSchema from 'cast-with-schema';
import { StepConfig } from '../../../../models';

export function buildInputPropsFromContext(
  context: WorkflowContext,
  config: StepConfig,
  schema: Schema
): unknown {
  // const interpolatedProps: Record<string, unknown> = { ...config.props };
  // // TODO: This needs to interpolate nested objects
  // for (const key in interpolatedProps) {
  //   // eslint-disable-next-line security/detect-object-injection
  //   const value = interpolatedProps[key];
  //   if (typeof value === 'string') {
  //     // eslint-disable-next-line security/detect-object-injection
  //     interpolatedProps[key] = renderFn(value, resolveTemplate, context);
  //   }
  // }

  const interpolatedProps = interpolateDeeply(config.props || {}, context);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const castedProps = castWithSchema(interpolatedProps, schema);
  return castedProps;
}

function interpolateDeeply(value: Record<string, unknown>, context: WorkflowContext): unknown {
  if (value === null || value === undefined) {
    return {};
  }
  if (typeof value === 'string') {
    return renderFn(value, resolveTemplate, context);
  }
  if (typeof value === 'object' && value !== null && value !== undefined && !Array.isArray(value)) {
    const newValue: Record<string, unknown> = {};
    for (const key in value) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, security/detect-object-injection
      const val = value[key] as Record<string, unknown>;
      // eslint-disable-next-line security/detect-object-injection
      newValue[key] = interpolateDeeply(val, context);
    }
    return newValue;
  }
  return value;
}

function resolveTemplate(varName: string, scope?: Scope): string {
  if (!scope) {
    throw Error('Scope is required');
  }
  const value = get(scope, varName) as unknown;
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return JSON.stringify(value);
  }
  return value as string;
}
